import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import "./layout.css";
import { Box, Typography } from "@mui/material";
import CartHeader from "../components/ui/childHeader/CartHeader";
import EmptyScreen from "../components/ui/emptyScreen/EmptyScreen";
import { ReactComponent as GatiError } from "../assets/images/GatiError.svg";
import { useGlobalContext } from "../context/GlobalContext";
import OrderComplete from "../components/ui/OrderComplete";
import OrderDetails from "../components/ui/order-details/OrderDetails";
import { ReactComponent as OrderEdit } from "../assets/icons/order_icon/orderedit_icon.svg";
import { ReactComponent as Download } from "../assets/icons/order_icon/download.svg";
import { ReactComponent as CrossIcon } from "../assets/icons/order_icon/whitecross_icon.svg";
import GatiErrorModal from "../components/ui/modals/GatiErrorModal/GatiErrorModal";

const CartLayout = () => {
  const {
    cartScreen,
    setCartScreen,
    orderComplete,
    orderDetails,
    scanned,
    setGalleryView,
    gatiError,
    setGatiError
  } = useGlobalContext();

  useEffect(() => {
    const user = localStorage.getItem("scanned");
    if (user) {
      setCartScreen(true);
    }
    return () => {
      setCartScreen(false);
      setGalleryView(false);
    };
  }, [scanned]);

  return (
    <Box className="main-container">
      <Box className="secondary-container">
        <Box className="main-section">
          { !gatiError && cartScreen && <CartHeader />}
          { !gatiError && !orderDetails && !orderComplete && !cartScreen && (
            <EmptyScreen page="cart" />
          )}
          {orderComplete && !orderDetails && <OrderComplete />}
          {!gatiError && orderDetails && <OrderDetails />}
          {!gatiError && cartScreen && <Outlet />}
          {<GatiErrorModal  openModal={gatiError} handleClose={()=> setGatiError(false)} />}
          {false && (
            <Box
              sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  width: "16vw",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: ".5vw",
                  position: "relative",
                }}
              >
                <CrossIcon
                  style={{
                    cursor: "pointer",
                    position: "absolute",
                    top: -40,
                    right: -40,
                  }}
                />

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "1vw",
                    height: "16vw",
                    width: "100%",
                    background: "#0D0D0D",
                    borderRadius: "1vw",
                  }}
                >
                  <Typography fontFamily={"Poppins"} fontSize={"1vw"}>
                    #3486538
                  </Typography>
                  <GatiError />
                  <Typography fontFamily={"Poppins"} fontSize={".9vw"}>
                    Sorry, Gati’s Server is Down!
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <Box
                    style={{ display: "flex", gap: ".25vw", cursor: "pointer" }}
                  >
                    <OrderEdit />
                    <Typography
                      sx={{
                        fontFamily: "Poppins",
                        fontSize: ".7vw",
                        fontWeight: 500,
                        color: "#50C878",
                        textDecoration: "underline",
                      }}
                    >
                      Edit Order
                    </Typography>
                  </Box>
                  <Box
                    style={{
                      display: "flex",
                      gap: ".25vw",
                      cursor: "pointer",
                      alignItems: "center",
                    }}
                  >
                    <Download />
                    <Typography
                      sx={{
                        fontFamily: "Poppins",
                        fontSize: ".7vw",
                        fontWeight: 500,
                        color: "#5078C8",
                        textDecoration: "underline",
                      }}
                    >
                      Excel
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};
export default CartLayout;
